import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useMemo, useState } from 'react';
import copy from 'copy-to-clipboard';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ChainIcon, useModal, useShortenURL, BASE_URL, useResponsiveBreakPoints } from '@restworld/utils-common';
import { BaseModal, Button, Title } from '../..';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AmbassadorButton = function AmbassadorButton(_ref) {
  var url = _ref.url,
      type = _ref.type,
      regenerateURL = _ref.regenerateURL,
      loading = _ref.loading;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var _useState = useState(false),
      isCopied = _useState[0],
      setIsCopied = _useState[1];

  var _useModal = useModal(),
      show = _useModal.show,
      open = _useModal.open,
      _close = _useModal.close;

  var copyLink = useCallback(function () {
    copy(url);
    setIsCopied(true);
  }, [url]);
  var isSuccess = useMemo(function () {
    return type === 'success';
  }, [type]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      icon: "ShareSmallIcon",
      variant: "black-outline",
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return regenerateURL();

              case 2:
                open();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })),
      loading: loading,
      withLabelUnderneathIcon: true,
      title: isDesktop ? 'Share' : '',
      loaderSize: "sm",
      twStyle: {
        "maxHeight": "48px"
      }
    }), /*#__PURE__*/_jsx(PopupModalMessage, {
      show: show,
      close: function close() {
        _close();

        setIsCopied(false);
      },
      headIcon: /*#__PURE__*/_jsx(ChainIcon, {
        stroke: isSuccess ? "#007740" : "#cc0022"
      }),
      title: /*#__PURE__*/_jsx(Title, {
        content: isSuccess ? t('common:link_created_successfully') : t('job-explorer-page:share_this_job_title'),
        fontSize: "superSuperLarge",
        fontWeight: "bold",
        twStyle: {
          "lineHeight": "2.25rem"
        }
      }),
      subTitle: /*#__PURE__*/_jsx("div", {
        onClick: copyLink,
        children: /*#__PURE__*/_jsx(Title, {
          content: !isSuccess ? t('job-explorer-page:try_again_to_generate_a_new_link') : url,
          textColor: "gray-600",
          fontWeight: "normal",
          fontSize: "extraLarge",
          twStyle: {
            "lineHeight": "1.5rem"
          },
          suffixIcon: isCopied ? 'ClipboardDocumentCheckGreenIcon' : isSuccess ? 'ClipboardDocumentIcon' : undefined,
          isPointer: true
        })
      }),
      submitButton: /*#__PURE__*/_jsx(Button, {
        loading: loading,
        fullwidth: true,
        title: isCopied ? t('common:link_copied') : !isSuccess ? t('common:recreate_link') : t('common:copy_link'),
        variant: "normal",
        onClick: function onClick() {
          if (isSuccess) {
            copyLink();
          } else regenerateURL();
        }
      })
    })]
  });
};
export default AmbassadorButton;

var PopupModalMessage = function PopupModalMessage(_ref3) {
  var show = _ref3.show,
      close = _ref3.close,
      subTitle = _ref3.subTitle,
      title = _ref3.title,
      submitButton = _ref3.submitButton,
      headIcon = _ref3.headIcon;
  return /*#__PURE__*/_jsx(BaseModal, {
    open: show,
    onClose: close,
    layout: 'drawer',
    showMobileGestures: true,
    modalStyles: [{
      "maxWidth": "32rem"
    }],
    children: /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [headIcon, /*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [title, subTitle]
      }), submitButton]
    })
  });
};

export var useShortUrl = function useShortUrl() {
  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(''),
      shortUrl = _useState3[0],
      setShortUrl = _useState3[1];

  var _useShortenURL = useShortenURL(),
      getShortenURL = _useShortenURL.getShortenURL;

  var _useRouter = useRouter(),
      query = _useRouter.query;

  var callApi = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(refCode) {
      var urlQueryParams, longURL, urlResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              urlQueryParams = generateQueryString(_objectSpread(_objectSpread({}, query), {}, {
                utm_source: 'referral',
                utm_medium: 'ambassador',
                utm_campaign: 'worker_acquisition',
                ref_code: refCode
              }));
              longURL = "".concat(BASE_URL, "/cerco-lavoro").concat(urlQueryParams);
              _context2.next = 5;
              return getShortenURL({
                longURL: longURL
              });

            case 5:
              urlResponse = _context2.sent;
              setShortUrl(urlResponse);
              setLoading(false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [getShortenURL, query]);
  return {
    shortUrl: shortUrl,
    loading: loading,
    getShortenURL: callApi
  };
};

var generateQueryString = function generateQueryString(query) {
  var queryString = Object.keys(query).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(query[key]));
  }).join('&');
  return "?".concat(queryString);
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "ambassador-button___StyledDiv",
  componentId: "sc-11xno3n-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "2rem",
  "textAlign": "center"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "ambassador-button___StyledDiv2",
  componentId: "sc-11xno3n-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem"
});